export default __webpack_public_path__ + "static/media/ic_polygon_96.c7ad5028.svg";